"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseChart = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2018 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var highcharts_1 = require("../../highcharts");
var sdk_ui_vis_commons_1 = require("@gooddata/sdk-ui-vis-commons");
var noop_1 = tslib_1.__importDefault(require("lodash/noop"));
var defaultProps_1 = require("../_commons/defaultProps");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var sanitizeStacking_1 = require("../_commons/sanitizeStacking");
var sdk_ui_theme_provider_1 = require("@gooddata/sdk-ui-theme-provider");
var StatelessBaseChart = /** @class */ (function (_super) {
    tslib_1.__extends(StatelessBaseChart, _super);
    function StatelessBaseChart(props) {
        var _this = _super.call(this, props) || this;
        _this.errorMap = sdk_ui_1.newErrorMapping(props.intl);
        return _this;
    }
    StatelessBaseChart.prototype.render = function () {
        var _a = this.props, dataView = _a.dataView, error = _a.error, isLoading = _a.isLoading;
        var ErrorComponent = this.props.ErrorComponent;
        var LoadingComponent = this.props.LoadingComponent;
        if (error) {
            var errorProps = this.errorMap[Object.prototype.hasOwnProperty.call(this.errorMap, error)
                ? error
                : sdk_ui_1.ErrorCodes.UNKNOWN_ERROR];
            return ErrorComponent ? react_1.default.createElement(ErrorComponent, tslib_1.__assign({ code: error }, errorProps)) : null;
        }
        // when in pageble mode (getPage present) never show loading (its handled by the component)
        if (isLoading || !dataView) {
            return LoadingComponent ? react_1.default.createElement(LoadingComponent, null) : null;
        }
        return this.renderChartTransformation();
    };
    StatelessBaseChart.prototype.renderChartTransformation = function () {
        var _a = this.props, afterRender = _a.afterRender, height = _a.height, width = _a.width, locale = _a.locale, config = _a.config, type = _a.type, dataView = _a.dataView, onDataTooLarge = _a.onDataTooLarge, pushData = _a.pushData, theme = _a.theme, drillableItems = _a.drillableItems, onDrill = _a.onDrill, onNegativeValues = _a.onNegativeValues, onLegendReady = _a.onLegendReady;
        var colorPalette = highcharts_1.getValidColorPalette(config);
        var fullConfig = tslib_1.__assign(tslib_1.__assign({}, config), { type: type, colorPalette: colorPalette });
        var sanitizedConfig = sanitizeStacking_1.getSanitizedStackingConfig(dataView.definition, fullConfig);
        return (react_1.default.createElement(sdk_ui_theme_provider_1.ThemeContextProvider, { theme: theme, themeIsLoading: false },
            react_1.default.createElement(sdk_ui_1.IntlWrapper, { locale: locale },
                react_1.default.createElement(sdk_ui_1.IntlTranslationsProvider, null, function (translationProps) {
                    // TODO: this is evil; mutating the items of readonly array; need to find a conceptual way to do this
                    sdk_ui_vis_commons_1.fixEmptyHeaderItems(dataView, translationProps.emptyHeaderString);
                    return (react_1.default.createElement(highcharts_1.ChartTransformation, { height: height, width: width, config: sanitizedConfig, drillableItems: drillableItems, locale: locale, dataView: dataView, afterRender: afterRender, onDrill: onDrill, onDataTooLarge: onDataTooLarge, onNegativeValues: onNegativeValues, onLegendReady: onLegendReady, pushData: pushData, numericSymbols: translationProps.numericSymbols }));
                }))));
    };
    StatelessBaseChart.defaultProps = tslib_1.__assign(tslib_1.__assign({}, defaultProps_1.defaultCoreChartProps), { onDataTooLarge: noop_1.default, onLegendReady: noop_1.default, config: {} });
    return StatelessBaseChart;
}(react_1.default.Component));
/**
 * NOTE: exported to satisfy sdk-ui-ext; is internal, must not be used outside of SDK; will disappear.
 *
 * @internal
 */
exports.BaseChart = sdk_ui_1.withEntireDataView(StatelessBaseChart);
//# sourceMappingURL=BaseChart.js.map